export default {
  data() {
    return {
      mostrarFiltro: false,
      pagina: 1,
      qtPaginas: 1,
      qtResultados: 0,
      itemSelecionado: 10,
      rows: [],
      campoPesquisa: "",
      objetoTabela: {
        pagina: 1,
        tamanho: 10,
        ordenacao: "",
        direcao: "ASC"
      },
      objetoFiltro: {},
      loadingTabela: false,
      objetoFiltroLocal: {},
      objetoFiltroPuro: {},
      iniciado: false,
      usarStore: true
    };
  },
  methods: {
    trocarPagina(objetoPagina) {
      if (this.loadingTabela) return;
      this.pagina = objetoPagina.pagina;
      this.$set(this.objetoTabela, "pagina", this.pagina);
      this.iniciarTabela();
    },
    trocarElementoPagina(tamanho) {
      if (this.loadingTabela) return;

      this.pagina = 1;
      this.$set(this.objetoTabela, "pagina", 1);
      this.itemSelecionado = tamanho;
      this.objetoTabela.tamanho = tamanho;
      this.iniciarTabela();
    },
    ordenarColuna(coluna) {
      this.objetoTabela.direcao =
        this.objetoTabela.direcao === "ASC" ? "DESC" : "ASC";
      this.objetoTabela.ordenacao = coluna.campoOrdenacao;
      this.iniciarTabela();
    },
    /**
     * Método que padroniza os valores da tabela, também tem um callback com as linhas
     * @param {{ conteudo: Array, numeroPagina: Number, tamanhoPagina: Number, totalElementos: Number, totalPaginas: Number }} objetoTabela
     * @param {function(Array<Object>)} callback - Linhas da tabela
     */
    configurarTabela(objetoTabela, callback) {
      const {
        conteudo,
        numeroPagina,
        tamanhoPagina,
        totalElementos,
        totalPaginas
      } = objetoTabela;
      this.qtPaginas = totalPaginas;
      this.itemSelecionado = tamanhoPagina;
      this.qtResultados = totalElementos;
      this.pagina = numeroPagina;

      callback(conteudo);
    },

    /**
     * Método que é chamado logo após feito o clique em uma das linhas
     * @param {Number} index - linha que foi feito o clique
     */
    clickLinha(index) {
      const { id } = this.rows[index].naoMostrar;
      if ([null, undefined, ""].includes(id)) return;
      this.$router.push(
        this.$options.name + "/" + this.rows[index].naoMostrar.id
      );
    },
    /**
     * Método que é chamado logo após o botão de filtrar no componente de filtro for clicado
     * @param {Object} objetoFiltro
     */
    filtrar(objetoFiltro) {
      this.objetoFiltroLocal = {
        ...objetoFiltro
      };
      this.objetoFiltro = {
        ...this.objetoFiltro,
        ...objetoFiltro
      };
      this.$set(this.objetoTabela, "pagina", 1);
      this.mostrarFiltro = false;
      this.iniciarTabela();
    },
    /**
     * Método para limpar o filtro
     */
    limparFiltro() {
      this.objetoFiltroLocal = {};
      this.objetoFiltro = {};
      this.objetoFiltroPuro = {};
      this.limparPesquisa();
      this.mostrarFiltro = false;
      this.iniciarTabela();
      this.salvarFiltro();
    },
    /**
     * Método que salva os dados de paginação e filtro na store
     */
    salvarFiltro() {
      if (!this.usarStore) return;
      const obj = {
        objetoTabelaComputed: this.objetoTabelaComputed,
        objetoFiltroPuro: this.objetoFiltroPuro,
        campoPesquisa: this.campoPesquisa,
        objetoFiltroLocal: this.objetoFiltroLocal,
        objetoFiltro: this.objetoFiltro,
        objetoTabela: this.objetoTabela
      };
      this.$store.commit("setFiltroGenerico", {
        codigo: this.$options.name,
        objeto: obj
      });
    },
    objetoTabelaAtual() {
      let tempObjetoTabela = this.objetoTabelaComputed;
      if (this.filtroSalvo !== undefined && !this.iniciado) {
        const {
          objetoTabelaComputed,
          objetoFiltroPuro,
          campoPesquisa,
          objetoFiltroLocal,
          objetoFiltro,
          objetoTabela
        } = this.filtroSalvo;
        tempObjetoTabela = objetoTabelaComputed;
        this.objetoTabela = objetoTabela;
        this.objetoFiltro = objetoFiltro;
        this.objetoFiltroPuro = objetoFiltroPuro;
        this.campoPesquisa = campoPesquisa;
        this.objetoFiltroLocal = objetoFiltroLocal;

        this.$nextTick(() => {
          this.$refs["filtro"].setFiltro(objetoFiltroPuro);
        });
      }

      return tempObjetoTabela;
    },
    atualizarObjetoTabela(objeto) {
      this.$set(this, "objetoTabela", {
        ...this.objetoTabela,
        ...objeto
      });
    }
  },
  computed: {
    objetoTabelaComputed() {
      return {
        ...this.objetoTabela,
        ...this.objetoFiltro
      };
    },
    quantidadeFiltroNumero() {
      return Object.values(this.objetoFiltroLocal).filter(
        e => ![null, undefined, ""].includes(e)
      ).length;
    },
    /**
     * Retorna a quantidade de filtros aplicados
     */
    quantidadeFiltro() {
      const qtdFiltro = this.quantidadeFiltroNumero;
      if (qtdFiltro <= 0) return "";
      return qtdFiltro > 9 ? qtdFiltro : "0" + qtdFiltro;
    },
    /**
     * Recupera as informações salvas na store da tabela atual, isso se tiver.
     */
    filtroSalvo() {
      return (
        this.$store.getters.getFiltroGenerico &&
        this.$store.getters.getFiltroGenerico.get(this.$options.name)
      );
    }
  }
};
